import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { ArrowRight } from 'lucide-react';
export function PricingPage() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    workEmail: '',
    company: '',
    companySize: '',
    industry: '',
    workflow: '',
    currentInitiatives: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const pricingTiers = [{
    users: '1 - 20 users',
    perMonth: '$1,000',
    guardrails: '25'
  }, {
    users: '21 - 250 users',
    perMonth: '$5,000',
    guardrails: '125'
  }, {
    users: '251 - 2,500 users',
    perMonth: '$20,000',
    guardrails: '500'
  }, {
    users: '2,501 - 10,000 users',
    perMonth: 'Contact Us',
    guardrails: '1,000'
  }, {
    users: '10,001+ users',
    perMonth: 'Contact Us',
    guardrails: '3,000'
  }];
  const industries = ['Financial Services', 'Healthcare & Life Sciences', 'Marketing & Communications', 'Insurance', 'Medical Device', 'Consulting/Professional Services'];
  const partnerProfile = [{
    title: 'Scale',
    description: '500-100,000+ employees navigating AI adoption'
  }, {
    title: 'Regulation',
    description: 'Operating in compliance-heavy environments'
  }, {
    title: 'Active AI Programs',
    description: 'Current pilots or exploration initiatives'
  }, {
    title: 'Leadership Buy-in',
    description: 'Executive commitment to AI adoption'
  }];
  const partnershipFeatures = ['Workflow-by-workflow transformation', 'Build your Library of Enterprise Intelligence', 'Proof of concept → expansion path', 'Direct access to founding team'];
  return <div className="min-h-screen w-full bg-white selection:bg-[#0066FF] selection:text-white" data-id="element-2111">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-gray-100" data-id="element-2112">
        <div className="w-full px-6 md:px-12 lg:px-24" data-id="element-2113">
          <div className="max-w-7xl mx-auto h-20 flex items-center" data-id="element-2114">
            <Link to="/" data-id="element-2115">
              <img src="https://cdn.magicpatterns.com/uploads/9qJGNjQNSV94689CCZT1kr/newTM_black_copy.png" alt="Synthia" className="h-8" data-id="element-2116" />
            </Link>
            <Navigation data-id="element-2117" />
          </div>
        </div>
      </header>

      <main className="pt-20" data-id="element-2118">
        {/* Hero Section */}
        <section className="relative w-full pt-20 pb-32 px-6 md:px-12 lg:px-24 overflow-hidden bg-white" data-id="element-2119">
          <div className="absolute top-0 right-0 pointer-events-none" style={{
          width: '100%',
          height: '800px'
        }} data-id="element-2120">
            <img src="https://cdn.magicpatterns.com/uploads/kga88EcdPJUPTBaJUremGs/background_thought.png" alt="" className="absolute right-0 top-[12%] w-[100%] h-auto opacity-90" data-id="element-2121" />
          </div>

          <div className="max-w-7xl mx-auto relative z-10" data-id="element-2122">
            <div className="flex flex-col space-y-8" data-id="element-2123">
              <div className="inline-flex items-center px-3 py-1 rounded-full border border-gray-200 bg-gray-50 w-fit" data-id="element-2124">
                <span className="text-xs font-medium text-gray-600 uppercase tracking-wider font-sans" data-id="element-2125">
                  FOUNDING PARTNERS PROGRAM
                </span>
              </div>

              <h1 className="text-5xl md:text-7xl font-bold leading-[0.95] tracking-tight text-black max-w-6xl font-['Syne']" data-id="element-2126">
  Building <span className="bg-blue-600 text-white px-3" data-id="element-2127">together</span>
            </h1>

              <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-2xl font-light" data-id="element-2128">
                We're working with a select group of forward-thinking companies
                in regulated industries to define what compliant AI
                transformation looks like. This isn't just taking on
                clients—it's building in partnership.
              </p>
            </div>
          </div>
        </section>

        {/* Industries & Partnership Section */}
        <section className="py-24 px-6 md:px-12 lg:px-24 bg-[#F8F8F8]" data-id="element-2129">
          <div className="max-w-7xl mx-auto" data-id="element-2130">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-2131">
              {/* Industries */}
              <div data-id="element-2132">
                <h2 className="text-3xl md:text-4xl font-bold mb-8 font-['Syne']" data-id="element-2133">
                  Industries We're <br data-id="element-2134" />
                  Partnering With
                </h2>
                <div className="space-y-4" data-id="element-2135">
                  {industries.map((industry, index) => <div key={index} className="flex items-center gap-3 text-lg text-gray-700" data-id="element-2136">
                      <ArrowRight className="w-5 h-5 text-[#0066FF]" data-id="element-2137" />
                      <span data-id="element-2138">{industry}</span>
                    </div>)}
                </div>
              </div>

              {/* What Partnership Looks Like */}
              <div data-id="element-2139">
                <h2 className="text-3xl md:text-4xl font-bold mb-8 font-['Syne']" data-id="element-2140">
                  What Partnership <br data-id="element-2141" />
                  Looks Like
                </h2>
                <div className="space-y-4" data-id="element-2142">
                  {partnershipFeatures.map((feature, index) => <div key={index} className="flex items-center gap-3 text-lg text-gray-700" data-id="element-2143">
                      <ArrowRight className="w-5 h-5 text-[#0066FF]" data-id="element-2144" />
                      <span data-id="element-2145">{feature}</span>
                    </div>)}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Ideal Partner Profile */}
        <section className="py-24 px-6 md:px-12 lg:px-24 bg-white" data-id="element-2146">
          <div className="max-w-7xl mx-auto" data-id="element-2147">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-2148">
              {partnerProfile.map((item, index) => <div key={index} className="bg-white p-6 rounded border border-gray-200" data-id="element-2149">
                  <h3 className="text-xl font-bold mb-3 font-['Syne']" data-id="element-2150">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-2151">
                    {item.description}
                  </p>
                </div>)}
            </div>
          </div>
        </section>

        {/* Platform Pricing */}
      <section className="py-24 px-6 md:px-12 lg:px-24 bg-[#F8F8F8]" data-id="element-2152">
  <div className="max-w-7xl mx-auto" data-id="element-2153">
    <div className="text-center mb-12" data-id="element-2154">
      <span className="text-sm font-bold tracking-widest uppercase text-gray-400 mb-4 block font-sans" data-id="element-2155">
        PRICING
      </span>
      <h2 className="text-4xl md:text-5xl font-bold mb-6 font-['Syne']" data-id="element-2156">
        Guardrail Management System
      </h2>
      <p className="text-xl text-gray-600 font-light max-w-3xl mx-auto" data-id="element-2157">
        This isn't a cost center, you're building an asset class. Fast start 
        deployment includes custom guardrails, BrandKey, Role, compliance, tone, etc.
      </p>
    </div>
    
    {/* Pricing Table */}
          <div className="overflow-x-auto" data-id="element-2158">
  <table className="w-full max-w-4xl mx-auto bg-white border border-gray-200 rounded-lg" data-id="element-2159">
    <thead data-id="element-2160">
      <tr className="bg-gray-50 border-b border-gray-200" data-id="element-2161">
        <th className="px-8 py-4 text-left text-sm font-bold text-gray-700 font-['Syne'] w-1/3" data-id="element-2162">
          # of Users
        </th>
        <th className="px-8 py-4 text-left text-sm font-bold text-gray-700 font-['Syne'] w-1/3" data-id="element-2163">
          Per Month
        </th>
        <th className="px-8 py-4 text-left text-sm font-bold text-gray-700 font-['Syne'] w-1/3 bg-blue-50" data-id="element-2164">
          Managed Guardrails
        </th>
      </tr>
    </thead>
    <tbody data-id="element-2165">
      {pricingTiers.map((tier, index) => <tr key={index} className="border-b border-gray-200 hover:bg-gray-50 transition-colors" data-id="element-2166">
          <td className="px-8 py-4 text-gray-900 font-semibold" data-id="element-2167">
            {tier.users}
          </td>
          <td className="px-8 py-4 text-gray-900 font-semibold" data-id="element-2168">
            {tier.perMonth === 'Contact Us' ? <Link to="/contact" className="text-[#0066FF] underline hover:text-black" data-id="element-2169">
                Contact Us
              </Link> : tier.perMonth}
          </td>
          <td className="px-8 py-4 text-gray-900 font-semibold bg-blue-50" data-id="element-2170">
            {tier.guardrails}
          </td>
        </tr>)}
    </tbody>
  </table>
          </div>
    
    <div className="mt-8 space-y-4 text-gray-600 max-w-4xl mx-auto" data-id="element-2171">
      <p className="text-lg" data-id="element-2172">
        <strong className="text-black" data-id="element-2173">Example:</strong> Under 250 users
        = $5K/month, unlocking $2M+ value
      </p>
      <p data-id="element-2174">
        Fast start deployment includes custom guardrails, BrandKey,
        compliance, tone, etc.
      </p>
      <p data-id="element-2175">All BYO LLM. Managed LLM adds $20-25 per user.</p>
      <p className="text-sm italic" data-id="element-2176">
        * Additional guardrail components can be purchased
      </p>
    </div>
  </div>
      </section>

        {/* Application Form */}
        <section className="py-24 px-6 md:px-12 lg:px-24 bg-white" data-id="element-2177">
          <div className="max-w-4xl mx-auto" data-id="element-2178">
            <div className="text-center mb-12" data-id="element-2179">
              <h2 className="text-4xl md:text-5xl font-bold mb-6 font-['Syne']" data-id="element-2180">
                AI transformation at scale.
              </h2>
              <p className="text-xl text-gray-600 font-light" data-id="element-2181">
                We're selectively engaging with companies that see AI governance
                as a strategic advantage, not a compliance burden.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2182">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2183">
                <div data-id="element-2184">
                  <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2185">
                    First Name
                  </label>
                  <input type="text" id="firstName" name="firstName" value={formData.firstName} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2186" />
                </div>

                <div data-id="element-2187">
                  <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2188">
                    Last Name
                  </label>
                  <input type="text" id="lastName" name="lastName" value={formData.lastName} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2189" />
                </div>
              </div>

              <div data-id="element-2190">
                <label htmlFor="workEmail" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2191">
                  Work Email
                </label>
                <input type="email" id="workEmail" name="workEmail" value={formData.workEmail} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2192" />
              </div>

              <div data-id="element-2193">
                <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2194">
                  Company
                </label>
                <input type="text" id="company" name="company" value={formData.company} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2195" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-2196">
                <div data-id="element-2197">
                  <label htmlFor="companySize" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2198">
                    Company Size
                  </label>
                  <select id="companySize" name="companySize" value={formData.companySize} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2199">
                    <option value="" data-id="element-2200">Select range</option>
                    <option value="under-500" data-id="element-2201">Under 500</option>
                    <option value="500-3000" data-id="element-2202">500-3,000</option>
                    <option value="3000-10000" data-id="element-2203">3,000-10,000</option>
                    <option value="10000+" data-id="element-2204">10,000+</option>
                  </select>
                </div>

                <div data-id="element-2205">
                  <label htmlFor="industry" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2206">
                    Industry
                  </label>
                  <select id="industry" name="industry" value={formData.industry} onChange={handleChange} required className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2207">
                    <option value="" data-id="element-2208">Select industry</option>
                    <option value="financial" data-id="element-2209">Financial Services</option>
                    <option value="healthcare" data-id="element-2210">Healthcare/Life Sciences</option>
                    <option value="legal" data-id="element-2211">Legal</option>
                    <option value="insurance" data-id="element-2212">Insurance</option>
                    <option value="pharma" data-id="element-2213">Pharma</option>
                    <option value="other" data-id="element-2214">Other</option>
                  </select>
                </div>
              </div>

              <div data-id="element-2215">
                <label htmlFor="workflow" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2216">
                  What workflow or use case are you looking to transform?
                </label>
                <textarea id="workflow" name="workflow" value={formData.workflow} onChange={handleChange} required rows={4} placeholder="Describe the specific workflow, department, or challenge you're looking to address..." className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2217" />
              </div>

              <div data-id="element-2218">
                <label htmlFor="currentInitiatives" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-2219">
                  Current AI initiatives (if any)
                </label>
                <textarea id="currentInitiatives" name="currentInitiatives" value={formData.currentInitiatives} onChange={handleChange} rows={4} placeholder="Pilots, tools in use, governance frameworks..." className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#0066FF] focus:border-transparent" data-id="element-2220" />
              </div>

              <button type="submit" className="w-full group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-[#0066FF] font-['Syne'] hover:bg-black hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black" data-id="element-2221">
                <span data-id="element-2222">MEET THE TEAM</span>
                <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-2223" />
              </button>

              <p className="text-center text-sm text-gray-600 mt-4" data-id="element-2224">
                We review all applications and respond within 3 business days.
              </p>
            </form>
          </div>
        </section>
      </main>

      <Footer data-id="element-2225" />
    </div>;
}